import { render, staticRenderFns } from "./CPOAdvice.vue?vue&type=template&id=6e4f50e4"
import script from "./CPOAdvice.vue?vue&type=script&lang=js"
export * from "./CPOAdvice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports